import { generateQueryString } from "../../utils/queryString";
import { ISearchResults } from "../models/ISearchResults";

export default function getSearchResults(
  currentPageId: number,
  q: string,
  page: number,
  sort: string
): Promise<ISearchResults> {
  const params = {
    currentPageId,
    q,
    page,
    sort
  };

  return fetch(`/api/SearchApi/GetData?${generateQueryString(params)}`)
    .then((e) => e.json())
    .then((result) => {
      delete params.currentPageId;
      const clientQueryString = generateQueryString(params);
      window.history.replaceState(null, null, `?${clientQueryString}`);
      return result;
    });
}
